import { Injectable } from '@angular/core';
import { ShopSettings } from '../../booking/models/shop-settings';
import { ShopSettingsService } from './shop-settings.service';
import { map } from 'rxjs/operators';
import { ConnectionService } from '../../../services/connection/connection.service';
import { Observable, of } from '../../../../../node_modules/rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShopSettingsOdooService extends ShopSettingsService {

  constructor(
    private connectionService: ConnectionService,
  ) {
    super();
    // this.initialize().subscribe();
  }

  initialize(): Observable<boolean> {
    return this.loadSettings();
  }

  get shopSettings(): ShopSettings {
    return this._shopSettings;
  }

  loadSettings(): Observable<boolean> {
    return this.connectionService.sendJsonPostRequest('/store/settings', {
      profile: this.profile,
    })
      .pipe(map(
        x => {
          if (x) {
            this._shopSettings = ShopSettings.createFromAny(x);
            return true;
          }

          return false;
        }
      ));
  }
}
